var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"banner-custom-container"},[_c('div',{staticClass:"banner-section"},[_c('HomePageBanner')],1),_c('div',{staticClass:"login-section"},[_c('Login')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }